module.exports = __webpack_public_path__ + "static/senior-9-e6815a8fc1480d428d787ab989ad6359.png";